export const CREATE_PARAM = 'create' as const;

export type CreateParam = typeof CREATE_PARAM;

export const isCreateParam = (value: unknown): value is CreateParam =>
  value === CREATE_PARAM;
